'use strict';

export function generateGrid (columns, withCheckbox) {
	const columnString = columns.reduce(
		(acc, { width }) => `${acc} ${width ?? 'minmax(150px, 1fr)'}`,
		withCheckbox ? '120px ' : '',
	);
	return { display: 'grid', gridTemplateColumns: columnString };
}
